import { useState, useEffect } from 'react';
import { useContent } from '@/content';

export default function Navbar() {
  const c = useContent();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.8);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const links = [
    { label: c.nav.linkAbout, id: 'about' },
    { label: c.nav.linkBehandlungen, id: 'behandlungen' },
    { label: c.nav.linkMesoporation, id: 'mesoporation' },
    { label: c.nav.linkLeistungen, id: 'leistungen' },
    { label: c.nav.linkKontakt, id: 'kontakt' },
  ];

  return (
    <nav
      id="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        visible
          ? 'translate-y-0 opacity-100'
          : '-translate-y-full opacity-0'
      }`}
    >
      <div className="bg-white/90 backdrop-blur-md border-b border-blush-100 shadow-sm">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16 md:h-20">
            <button
              onClick={() => scrollTo('hero')}
              className="font-script text-2xl md:text-3xl text-champagne-500 hover:text-champagne-600 transition-colors whitespace-nowrap"
            >
              {c.nav.brand}
            </button>

            <div className="hidden md:flex items-center gap-8">
              {links.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollTo(link.id)}
                  className="text-sm font-medium text-gray-600 hover:text-champagne-500 transition-colors whitespace-nowrap tracking-wide"
                >
                  {link.label}
                </button>
              ))}
            </div>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center text-gray-600"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Menü"
            >
              <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-blush-100">
            <div className="px-4 py-4 space-y-3">
              {links.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollTo(link.id)}
                  className="block w-full text-left text-sm font-medium text-gray-600 hover:text-champagne-500 transition-colors py-2"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}